import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-test',
    templateUrl: './test.component.html',
    styleUrls: ['./test.component.scss'],
    standalone: false
})
export class TestPageComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
